import { Grid } from '@mui/material';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { setHashtagMetadata } from 'redux-store/slices/hashtag-slice';
import { isContentEmpty } from 'utils/helpers';
import { createHashtagPayload } from 'utils/mappers';

interface IRichTextContent {
  sx: any;
  content: string;
  projectId: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const RichTextContent = ({ sx, content, projectId, onClick }: IRichTextContent) => {
  const dispatch = useAppDispatch();

  if (!content || isContentEmpty(content)) return null;

  const html = content.replace(/(?<!href=["'])https?:\/\/[^\s<]+/g, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;

    const hashtagEl = target.closest('[data-mention-type="hashtag"]') as HTMLElement | null;

    if (hashtagEl) {
      const hashtagType = hashtagEl.getAttribute('data-hashtag-type') as HashtagMentionTypeEnum;
      const hashtagId = hashtagEl.getAttribute('data-hashtag-id');
      const mimeType = hashtagEl.getAttribute('data-mimeType');

      const payload = createHashtagPayload({
        type: hashtagType,
        id: Number(hashtagId),
        mimeType,
        projectId,
      });

      dispatch(setHashtagMetadata(payload));

      e.stopPropagation();
      return;
    }

    if (onClick) onClick(e);
  };

  return (
    <Grid sx={sx} onClick={handleClick}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Grid>
  );
};
